import { Paperclip, Trash2 } from "lucide-react";
import { SlateButton } from "components/Note/extras/extras";
import { ReactNode } from "react";
import { Transforms } from "slate";
import {
  ReactEditor,
  useFocused,
  useSelected,
  useSlateStatic,
} from "slate-react";

interface FileNoteProps {
  attributes: any;
  children: ReactNode;
  element: any;
}

export default function FileNote(props: FileNoteProps) {
  const { attributes, children, element } = props;
  const editor = useSlateStatic();
  const path = ReactEditor.findPath(editor, element);

  const selected = useSelected();
  const focused = useFocused();
  const label =
    typeof element.name === "string" && element.name.trim()
      ? element.name.trim()
      : "Archivo";

  return (
    <div {...attributes}>
      {children}
      <div contentEditable={false} style={{ display: "flex", marginTop: 4 }}>
        <div
          style={{
            position: "relative",
            display: "inline-flex",
            alignItems: "center",
            gap: 8,
            maxWidth: "100%",
            padding: "6px 10px",
            borderRadius: 8,
            border: selected && focused ? "1px solid #B4D5FF" : "1px solid #e2e8f0",
            background: "#f8fafc",
          }}
        >
          <Paperclip style={{ width: 14, height: 14, flexShrink: 0 }} />
          <a
            href={element.url}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: 13,
              fontWeight: 500,
              color: "#0a66c2",
              textDecoration: "underline",
              wordBreak: "break-all",
            }}
          >
            {label}
          </a>
          <SlateButton
            active
            onClick={() => Transforms.removeNodes(editor, { at: path })}
            style={{
              display: selected && focused ? "inline-flex" : "none",
              backgroundColor: "black",
              borderRadius: "100%",
              width: 22,
              height: 22,
              justifyContent: "center",
              alignItems: "center",
              flexShrink: 0,
            }}
          >
            <Trash2 className="h-3.5 w-3.5" />
          </SlateButton>
        </div>
      </div>
    </div>
  );
}
